// Redesign palette — "Clean & Minimal" (mockups/redesign/components.html).
// Brand red carries meaning only; three ink levels; hairline borders.
const vuetifyColors = {
    primary: '#D32946',          // brand
    secondary: '#A31C35',        // brand-dark (hover/pressed)
    accent: '#1A1A1A',
    error: '#D32946',            // one red app-wide
    warning: '#DE870A',
    warningInk: '#9C5A05',       // X150 (R72 L3): amber TEXT on warningTint (4.9:1, AA at 11px); the dots keep warning
    success: '#1E9E76',
    info: '#2477C8',
    white: '#ffffff',
    surface: '#FFFFFF',
    text: '#1A1A1A',             // ink
    charcoal: '#6B6B6B',         // ink-2
    textSubtle: '#9B9B9B',       // ink-3
    light: '#FAFAFA',            // page background
    borderLight: '#ECECEC',      // hairline
    border: '#D8D8D8',
    brandTint: '#FBEDF0',
    brandInk: '#BE233C',         // X152 (R73 L4): brand TEXT on brandTint (5.3:1, AA at 11px; primary was 4.4:1); icons and fills keep primary
    successTint: '#E7F6F1',
    warningTint: '#FCF3E4',
    facebook: '#4267B2',
    google: '#EA4335',
};
export default vuetifyColors;
